import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-tab-with-content-losaprily';
const html = `
<div data-attribute="tab-image-bg" class="tab-images-bg">
  <div data-attribute="tab-images-bg-item" class="tab-images-bg-item active" data-tab="tab-1" data-use-bg-mobile="true"
    data-bg-desktop-url="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3ca9e2f2bf845bca722d95.webp"
    data-bg-mobile-url="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3ca9e6fff3398990e7cc4c.webp"
    style="--bg-desktop-url:url('https://cdn.skyfastimg.com/images/2026/06/25/image-6a3ca9e2f2bf845bca722d95.webp'); --bg-mobile-url:url('https://cdn.skyfastimg.com/images/2026/06/25/image-6a3ca9e6fff3398990e7cc4c.webp')">
  </div>


  <div data-attribute="tab-images-bg-item" class="tab-images-bg-item " data-tab="tab-2" data-use-bg-mobile="true"
    data-bg-desktop-url="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3ca9ecd626431eabd9a44d.webp"
    data-bg-mobile-url="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3ca9f0a5b8cd61d7be4d9a.webp"
    style="--bg-desktop-url:url('https://cdn.skyfastimg.com/images/2026/06/25/image-6a3ca9ecd626431eabd9a44d.webp'); --bg-mobile-url:url('https://cdn.skyfastimg.com/images/2026/06/25/image-6a3ca9f0a5b8cd61d7be4d9a.webp')">
  </div>


  <div data-attribute="tab-images-bg-item" class="tab-images-bg-item " data-tab="tab-3" data-use-bg-mobile="true"
    data-bg-desktop-url="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3ca9f8e9b4e06b210fcaf4.webp"
    data-bg-mobile-url="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3ca9fc09caf1eb799907e9.webp"
    style="--bg-desktop-url:url('https://cdn.skyfastimg.com/images/2026/06/25/image-6a3ca9f8e9b4e06b210fcaf4.webp'); --bg-mobile-url:url('https://cdn.skyfastimg.com/images/2026/06/25/image-6a3ca9fc09caf1eb799907e9.webp')">
  </div>
</div>
<div class="container">
  <div class="tabs-heading" data-attribute="tabs-heading" data-color-border="#fe7b01" style="--color-border: #fe7b01">
    <div class="tab-deading-item active" data-attribute="tab-heading-item" data-tab="tab-1">
      <span data-attribute="tab-text-content" class="tab-text-content">Stabil talp</span>
    </div>


    <div class="tab-deading-item " data-attribute="tab-heading-item" data-tab="tab-2">
      <span data-attribute="tab-text-content" class="tab-text-content">Biztonságos fészek</span>
    </div>


    <div class="tab-deading-item " data-attribute="tab-heading-item" data-tab="tab-3">
      <span data-attribute="tab-text-content" class="tab-text-content">Több légkamra</span>
    </div>
  </div>
  <div data-attribute="tabs-content" class="tabs-content" data-width-tab-content-item="576"
    style="--width-tab-content-item:576px;">
    <div class="tab-content-item active" data-attribute="tab-content-item" data-tab="tab-1">
      <div data-show="true" data-attribute="sub-title" class="sub-title" style="">
        <h4>Felborulás elleni védelem</h4>
      </div>
      <div data-attribute="title-tab-item">
        <h2>STABIL, MINT EGY REPÜLŐGÉP SZÁRNYA 1</h2>
        <p>Az extra széles szárnyak és a háromszög alakú talp megakadályozzák a felborulást, így gyermeked mindig
          biztonságban van.</p>
      </div>
      <div data-attribute="key-benefits" data-color-benefit="#0079eb" data-show="true" class="key-benefits"
        style="--color-benefit: #0079eb; ">

        <div data-attribute="benefit-item" class="benefit-item">
          <div class="icon-benefit">
            <img data-attribute="icon-benefit"
              src="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3c9d138dad108f48397a16.png" alt="">
          </div>
          <div class="text-benefit">Kiszélesített oldalszárnyak</div>
        </div>


        <div data-attribute="benefit-item" class="benefit-item">
          <div class="icon-benefit">
            <img data-attribute="icon-benefit"
              src="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3c9d138dad108f48397a16.png" alt="">
          </div>
          <div class="text-benefit">Háromszög alakú, stabil talp</div>
        </div>


        <div data-attribute="benefit-item" class="benefit-item">
          <div class="icon-benefit">
            <img data-attribute="icon-benefit"
              src="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3c9d138dad108f48397a16.png" alt="">
          </div>
          <div class="text-benefit">Felborulásgátló védőrendszer</div>
        </div>

      </div>
    </div>


    <div class="tab-content-item " data-attribute="tab-content-item" data-tab="tab-2">
      <div data-show="true" data-attribute="sub-title" class="sub-title" style="">
        <h4>Felborulás elleni védelem</h4>
      </div>
      <div data-attribute="title-tab-item">
        <h2>STABIL, MINT EGY REPÜLŐGÉP SZÁRNYA 2</h2>
        <p>Az extra széles szárnyak és a háromszög alakú talp megakadályozzák a felborulást, így gyermeked mindig
          biztonságban van.</p>
      </div>
      <div data-attribute="key-benefits" data-color-benefit="#0079eb" data-show="true" class="key-benefits"
        style="--color-benefit: #0079eb; ">

        <div data-attribute="benefit-item" class="benefit-item">
          <div class="icon-benefit">
            <img data-attribute="icon-benefit"
              src="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3c9d138dad108f48397a16.png" alt="">
          </div>
          <div class="text-benefit">Kiszélesített oldalszárnyak</div>
        </div>


        <div data-attribute="benefit-item" class="benefit-item">
          <div class="icon-benefit">
            <img data-attribute="icon-benefit"
              src="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3c9d138dad108f48397a16.png" alt="">
          </div>
          <div class="text-benefit">Háromszög alakú, stabil talp</div>
        </div>


        <div data-attribute="benefit-item" class="benefit-item">
          <div class="icon-benefit">
            <img data-attribute="icon-benefit"
              src="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3c9d138dad108f48397a16.png" alt="">
          </div>
          <div class="text-benefit">Felborulásgátló védőrendszer</div>
        </div>

      </div>
    </div>


    <div class="tab-content-item " data-attribute="tab-content-item" data-tab="tab-3">
      <div data-show="true" data-attribute="sub-title" class="sub-title" style="">
        <h4>Felborulás elleni védelem</h4>
      </div>
      <div data-attribute="title-tab-item">
        <h2>STABIL, MINT EGY REPÜLŐGÉP SZÁRNYA 3</h2>
        <p>Az extra széles szárnyak és a háromszög alakú talp megakadályozzák a felborulást, így gyermeked mindig
          biztonságban van.</p>
      </div>
      <div data-attribute="key-benefits" data-color-benefit="#0079eb" data-show="true" class="key-benefits"
        style="--color-benefit: #0079eb; ">

        <div data-attribute="benefit-item" class="benefit-item">
          <div class="icon-benefit">
            <img data-attribute="icon-benefit"
              src="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3c9d138dad108f48397a16.png" alt="">
          </div>
          <div class="text-benefit">Kiszélesített oldalszárnyak</div>
        </div>


        <div data-attribute="benefit-item" class="benefit-item">
          <div class="icon-benefit">
            <img data-attribute="icon-benefit"
              src="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3c9d138dad108f48397a16.png" alt="">
          </div>
          <div class="text-benefit">Háromszög alakú, stabil talp</div>
        </div>


        <div data-attribute="benefit-item" class="benefit-item">
          <div class="icon-benefit">
            <img data-attribute="icon-benefit"
              src="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3c9d138dad108f48397a16.png" alt="">
          </div>
          <div class="text-benefit">Felborulásgátló védőrendszer</div>
        </div>

      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css);
